import axios, { AxiosResponse } from 'axios';

// DELETE
// Remove plant.
// /ewosapi/v1/bestmix/plant/{code}
export const deleteBestmixPlant = async (code: string, idx: number): Promise<number> => {
  await axios.delete<AxiosResponse>(`/ewosapi/v1/bestmix/plant/${code}`);
  return idx;
};
